import { Box, Card, CardContent, CircularProgress, Grid, Typography, useTheme } from '@mui/material';
import { IComanda } from '../../commons/types/crm';
import { themeConstants } from '../../commons/theme';
import { useTranslation } from '../../commons/useTranslasion';
import { Link } from 'react-router-dom';
import WorkIcon from '@mui/icons-material/Work';

interface CardComandaProps {
  titulo: string;
  totalComandas: number;
  loading: boolean;
  icon?: React.ElementType;
  linkTo?: string;

}

export const CardComanda: React.FC<CardComandaProps> = ({ titulo, totalComandas, loading, icon: Icon = WorkIcon, linkTo }) => {
  const { translate } = useTranslation();
  const { spacing, colors } = themeConstants;
  
  const cardContent = (
    <Card
      elevation={2}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        textAlign: 'center',
        transition: 'transform 0.2s, box-shadow 0.2s',
        cursor: linkTo ? 'pointer' : 'default',
        '&:hover': linkTo ? {
          transform: 'translateY(-4px)',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        } : {}
      }}
    >
      <CardContent sx={{ 
        padding: spacing.sm, 
        paddingBottom: spacing.sm, 
        flexGrow: 1, 
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '120px',
        maxHeight: '160px'
      }}>
        {/* Ícone centralizado no topo */}
        <Box sx={{ mb: 0.5 }}>
          {Icon && <Icon sx={{ color: colors.blue.main, fontSize: 24 }} />}
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" py={4}>
            <CircularProgress size={40} />
          </Box>
        ) : (
          <>
            {/* Número grande e centralizado */}
            <Typography 
              variant="h3" 
              fontWeight={600} 
              color="textPrimary" 
              sx={{ 
                fontSize: '1.8rem',
                mb: 0.5
              }}
            >
              {totalComandas}
            </Typography>
            
            {/* Título centralizado abaixo do número */}
            <Typography 
              variant="body1" 
              fontWeight={500} 
              color="textPrimary" 
              sx={{ mb: 1, fontSize: '0.85rem' }}
            >
              {titulo}
            </Typography>
            
            {/* Removido o botão "Ver todos" já que o card inteiro é clicável */}
          </>
        )}
      </CardContent>
    </Card>
  );

  // Envolva o cartão com Link se houver um destino
  return linkTo && totalComandas > 0 ? (
    <Link to={linkTo} style={{ textDecoration: 'none' }}>
      {cardContent}
    </Link>
  ) : cardContent;
};
